export const CONSENT_COOKIE_KEY = "cookie_consent";

// Consent is asked again after this period, so a past decision is not kept indefinitely
export const CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 180;

export const CONSENT_STATUS = {
	GRANTED: "granted",
	DENIED: "denied"
}

export const CONSENT_CHANNEL_NAME = "cookie_consent";
